<label *ngIf="label" class="font-headline-4 mb-8">{{ label }}</label>
<div class="c-form-field--group-checkbox">
  <div class="w100" *ngIf="!hideSelectAll">
    <p500-ui-checkbox-field label="Select All" i18n-label="@@common.select_all" [formControl]="selectAllControl" />
    <div class="c-line--horizontal mt-8">
      <div class="c-line__line"></div>
    </div>
  </div>
  <p500-ui-checkbox-field *ngFor="let field of data | keyvalue" [label]="field.value" [formControl]="formGroup.controls[field.key]" />
</div>
